import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, Transition as _Transition, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_delegate_cash.svg'


const _withScopeId = n => (_pushScopeId("data-v-a237eec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "delegation-registry"
}
const _hoisted_2 = { class: "delegation-registry__drop-down" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://delegate.cash",
  target: "_blank",
  rel: "noopener noreferrer"
}, "Eligible Wallets", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "delegation-registry__logo",
  src: _imports_0
}
const _hoisted_6 = { class: "delegation-registry__selected" }
const _hoisted_7 = {
  key: 0,
  target: "_blank",
  href: "https://delegate.cash"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import {
  ChevronDownIcon
} from '@heroicons/vue/20/solid';
import { computed } from 'vue';
import {
  abbreviateAddress
} from '@/lib/claimUtil';

interface DelegationPickerProps {
  selectedWallet: string;
  delegatedWallet: string;
  vaultWallets: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DelegationPicker',
  props: {
    selectedWallet: null,
    delegatedWallet: null,
    vaultWallets: null
  },
  emits: ['walletSelect'],
  setup(__props: any, { emit }) {

const props = __props as {
  selectedWallet: string;
  delegatedWallet: string;
  vaultWallets: string[];
};



// only show if there are more than 1 vault wallet, and the connected wallet is not the only elgible wallet
const show = computed(() => {
  return props.vaultWallets.length > 0 && !(props.vaultWallets.length === 1 && props.vaultWallets[0] === props.delegatedWallet);
});



const selectWallet = (address: string) => {
  emit('walletSelect', address);
};


return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (__props.vaultWallets.length > 0)
            ? (_openBlock(), _createBlock(_unref(Menu), {
                key: 0,
                as: "div",
                class: "delegation-registry__menu"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MenuButton), { class: "delegation-registry__menu-button" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChevronDownIcon), {
                        class: "h-2 w-2 p-0",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MenuItems), { class: "delegation-registry__popup" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.vaultWallets, (address) => {
                            return (_openBlock(), _createBlock(_unref(MenuItem), { key: address }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "delegation-registry__address",
                                  onClick: ($event: any) => (selectWallet(address))
                                }, [
                                  _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                                    [_vShow, address.toLowerCase() !== __props.delegatedWallet.toLowerCase()]
                                  ]),
                                  _createElementVNode("span", null, _toDisplayString(_unref(abbreviateAddress)(address)), 1)
                                ], 8, _hoisted_4)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (__props.delegatedWallet.toLowerCase() !== __props.selectedWallet.toLowerCase())
            ? (_openBlock(), _createElementBlock("a", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(abbreviateAddress)(__props.selectedWallet)), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})